import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import H2 from '@Components/H2';
import styles from './HowItWork.module.css';

import type { HowItWorkPartialData } from '../../typings';
import type { FC, HTMLAttributes } from 'react';

export interface HowItWorkProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  data: HowItWorkPartialData;
}

const HowItWork: FC<HowItWorkProps> = (props) => {
  const { className, data, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.howItWork, className)}>
      <H2 title={data.title} className={styles.title} />

      <div className={styles.stepsList}>
        {data.list.map((item) => (
          <div key={item.text} className={styles.step}>
            {!!item.image && (
              <Img className={cn(styles.icon, styles[item.image.id])} src={item.image.src} />
            )}
            <span className={styles.stepText}>{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(HowItWork);
